/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./SocialWhatsapp.vue?vue&type=template&id=d886dc7e&"
import script from "./SocialWhatsapp.vue?vue&type=script&lang=js&"
export * from "./SocialWhatsapp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports